
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.5662',
  depVersions: {
  "embedded-viral-link-ui": "static-1.5662",
  "head-dlb": "static-1.4360",
  "hs-test-utils": "static-1.7385",
  "hubspot-dlb": "static-2.1707",
  "HubStyleTokens": "static-2.10907",
  "I18n": "static-7.1461",
  "jasmine-runner": "static-1.5814",
  "quartz": "static-1.6205",
  "quartz-core": "static-1.5424",
  "react-dlb": "static-1.63",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.610",
  "enviro": "static-4.328",
  "foundations-components": "static-1.6916",
  "history": "static-4.47",
  "hub-http": "static-1.5499",
  "hubspot-url-utils": "static-1.3531",
  "HubStyle": "static-2.11215",
  "icons": "static-2.598",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6582",
  "PortalIdParser": "static-2.306",
  "quick-fetch": "static-1.3414",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.16004",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.4771",
  "react-virtualized": "static-2.83",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.17695",
  "signup-ui-lego-core": "static-1.19705",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.477",
  "ui-addon-react-router-dom": "static-1.8998",
  "ui-images": "static-2.974",
  "UIComponents": "static-3.7854",
  "usage-tracker": "static-1.6816",
  "usage-tracker-core": "static-1.6666",
  "viral-links-lib": "static-1.6307",
  "hs-promise-rejection-tracking": "static-1.4750",
  "raven": "static-3.5229",
  "raven-hubspot": "static-1.5536",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9058",
  "bend-plugin-trellis-migration": "static-1.2913",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2482",
  "quartz-webpack": "static-1.2429",
  "HeadJS": "static-2.628",
  "framer-motion": "static-1.54",
  "hs-test-utils-bend-plugin": "static-1.2496",
  "msw": "static-1.39",
  "testing-library": "static-1.136",
  "foundations-theming": "static-1.3732",
  "i18n-data": "static-1.210",
  "moment-timezone": "static-5.69",
  "jasmine": "static-4.3703",
  "quartz-core-utils": "static-1.3072",
  "dispatcher": "static-1.122",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.705",
  "hub-http-shared-msw-handlers": "static-1.8546",
  "hubspotter-http": "static-1.4039",
  "hubspotter-http-shared-msw-handlers": "static-1.8544",
  "mobile-manifest-mixins": "static-1.400",
  "platform-navigation-bootstrap": "static-1.11922",
  "ui-fonts": "static-1.335",
  "sassPrefix": "static-1.143",
  "bend-plugin-foundations-components": "static-1.3185",
  "floating-ui": "static-1.42",
  "foundations-assets": "static-1.4252",
  "foundations-theming-specialty": "static-1.1448",
  "hs-story-utils": "static-1.8766",
  "react-aria": "static-1.44",
  "tanstack-table": "static-1.23",
  "superstore": "static-1.4112",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4088",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7478",
  "bender-build-tools": "static-1.2573",
  "bend-plugin-foundations-theming": "static-1.2215",
  "foundations-theming-base": "static-1.2717",
  "ts-schema": "static-1.3563",
  "platform-infra-nav-components": "static-1.7138",
  "hs-lodash": "static-4.45"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.5662",
  "head-dlb": "/head-dlb/static-1.4360",
  "hs-test-utils": "/hs-test-utils/static-1.7385",
  "hubspot-dlb": "/hubspot-dlb/static-2.1707",
  "HubStyleTokens": "/HubStyleTokens/static-2.10907",
  "I18n": "/I18n/static-7.1461",
  "jasmine-runner": "/jasmine-runner/static-1.5814",
  "quartz": "/quartz/static-1.6205",
  "quartz-core": "/quartz-core/static-1.5424",
  "react-dlb": "/react-dlb/static-1.63",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.610",
  "enviro": "/enviro/static-4.328",
  "foundations-components": "/foundations-components/static-1.6916",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5499",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
  "HubStyle": "/HubStyle/static-2.11215",
  "icons": "/icons/static-2.598",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6582",
  "PortalIdParser": "/PortalIdParser/static-2.306",
  "quick-fetch": "/quick-fetch/static-1.3414",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.16004",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.4771",
  "react-virtualized": "/react-virtualized/static-2.83",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.17695",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19705",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.477",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8998",
  "ui-images": "/ui-images/static-2.974",
  "UIComponents": "/UIComponents/static-3.7854",
  "usage-tracker": "/usage-tracker/static-1.6816",
  "usage-tracker-core": "/usage-tracker-core/static-1.6666",
  "viral-links-lib": "/viral-links-lib/static-1.6307",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
  "raven": "/raven/static-3.5229",
  "raven-hubspot": "/raven-hubspot/static-1.5536",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9058",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2913",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2482",
  "quartz-webpack": "/quartz-webpack/static-1.2429",
  "HeadJS": "/HeadJS/static-2.628",
  "framer-motion": "/framer-motion/static-1.54",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2496",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.136",
  "foundations-theming": "/foundations-theming/static-1.3732",
  "i18n-data": "/i18n-data/static-1.210",
  "moment-timezone": "/moment-timezone/static-5.69",
  "jasmine": "/jasmine/static-4.3703",
  "quartz-core-utils": "/quartz-core-utils/static-1.3072",
  "dispatcher": "/dispatcher/static-1.122",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.705",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8546",
  "hubspotter-http": "/hubspotter-http/static-1.4039",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8544",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.400",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11922",
  "ui-fonts": "/ui-fonts/static-1.335",
  "sassPrefix": "/sassPrefix/static-1.143",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3185",
  "floating-ui": "/floating-ui/static-1.42",
  "foundations-assets": "/foundations-assets/static-1.4252",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1448",
  "hs-story-utils": "/hs-story-utils/static-1.8766",
  "react-aria": "/react-aria/static-1.44",
  "tanstack-table": "/tanstack-table/static-1.23",
  "superstore": "/superstore/static-1.4112",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4088",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7478",
  "bender-build-tools": "/bender-build-tools/static-1.2573",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2215",
  "foundations-theming-base": "/foundations-theming-base/static-1.2717",
  "ts-schema": "/ts-schema/static-1.3563",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7138",
  "hs-lodash": "/hs-lodash/static-4.45"
}
};
